export default __webpack_public_path__ + "static/media/deputy-logo.e534bb15.png";